module.exports = __webpack_public_path__ + "emoji.499e5a6ea4bb7f3c7f43.jpg";


//////////////////
// WEBPACK FOOTER
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/assets/img/emoji.jpg
// module id = ../../../../../src/assets/img/emoji.jpg
// module chunks = styles